<template>
  <v-dialog id="dialog" v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" text class="primary--text">
        <v-icon small class="mr-1">add_box</v-icon>
        Add New Monitor
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Add New Monitor</v-card-title>
      <v-card-text>
        <form v-on:submit.prevent="createDeviceMonitor()">
          <v-text-field required label="Name" v-model="monitor.name" />

          <!-- Selectors -->
          <v-row align="center">
            <v-list dense class="ml-1">
              <v-subheader
                >Device Selectors
                <span
                  class="ml-1"
                  v-if="Object.keys(monitor.selectors).length > 0"
                >
                  (targeted devices: {{ devicesPagination.totalItems }})
                </span>
              </v-subheader>
              <v-list-item
                v-for="(label, key, i) in monitor.selectors"
                :key="`label-${key}-${i}`"
              >
                <v-list-item-content>
                  <v-chip outlined color="primary" class="justify-center">
                    {{ key }}:{{ label }}
                  </v-chip>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn icon color="error" @click="deleteSelector(key)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-row>
          <v-row align="center">
            <v-col cols="12" sm="5" md="5">
              <v-text-field required label="Key" v-model="newSelector.key" />
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <v-text-field
                required
                label="Value"
                v-model="newSelector.value"
              />
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn
                small
                :disabled="newSelector.key === '' || newSelector.value === ''"
                v-on:click.native="addSelector()"
                class="primary white--text"
              >
                Add
              </v-btn>
            </v-col>
          </v-row>
          <v-btn v-show="false" hidden type="submit"> </v-btn>
        </form>

        <div v-show="error">
          <v-alert type="error" outlined>
            {{ error }}
          </v-alert>
        </div>
      </v-card-text>
      <v-card-text>
        <p>
          Devices are checked every 60 seconds. Notifications can be configured
          once the new monitor is created.
        </p>        
      </v-card-text>
      <v-card-actions>
        <v-btn text v-on:click.native="dialog = false" class="primary--text"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          text
          :disabled="!monitor.name || Object.keys(monitor.selectors).length === 0"
          :loading="loading"
          v-on:click.native.stop="createDeviceMonitor()"
          class="primary--text"
          >Create</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.addbtn {
  margin: 0px;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 1;
}
</style>

<script>

export default {
  data() {
    return {
      dialog: false,
      monitor: {
        name: '',
        selectors: {},
        projectId: ''
      },
      newSelector: {
        key: '',
        value: ''
      }
    }
  },

  computed: {
    loading() {
      return this.$store.state.deviceMonitor.loading
    },
    error() {
      return this.$store.state.deviceMonitor.error
    },
    projectId() {
      return this.$route.params.project
    },
    devices() {
      return this.$store.state.device.devices
    },
    devicesPagination() {
      return this.$store.state.device.devicesPagination
    },
  },

  methods: {
    addSelector() {
      this.monitor.selectors[this.newSelector.key] = this.newSelector.value
      this.newSelector = {
        key: '',
        value: ''
      }
      this.fetchDevices()
    },
    deleteSelector(label) {
      delete this.monitor.selectors[label]

      this.fetchDevices()
    },
    async createDeviceMonitor() {
      this.monitor.projectId = this.projectId

      let payload = {
        projectId: this.projectId,
        name: this.monitor.name,
        selectors: this.monitor.selectors,
        notifications: this.monitor.notifications
      }

      await this.$store.dispatch('CreateDeviceMonitor', payload)
      if (this.error === null) {
        let q = {
          projectId: this.projectId
        }
        this.$store.dispatch('ListDeviceMonitors', q)
        this.resetForm()
      }
    },

    async fetchDevices() {
      let filter = ''

      for (const [key, value] of Object.entries(this.monitor.selectors)) {
        // console.log(`${key}: ${value}`);
        filter += `${key}:${value} `
      }

      let q = {
        projectId: this.projectId,
        query: filter,
        pageSize: 10,
        pageToken: '',
      }
      await this.$store.dispatch('GetDevices', q)
    },

    resetForm() {
      // closing dialog
      this.dialog = false

      // resetting form
      this.monitor.name = ''
      this.newSelector = {
        key: '',
        value: ''
      }
      this.monitor.selectors = {}
      this.monitor.notifications = []
    }
  }
}
</script>
